"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.TranslationContext = exports.toBabelLocale = exports.createTranslateFn = exports.resolveParams = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var isSimpleParams = function (simpleOrJSXParams) { return !Object.keys(simpleOrJSXParams).some(function (key) {
    return typeof simpleOrJSXParams[key] === 'function';
}); };
var getOnlyJsxParams = function (params) {
    return Object.keys(params).reduce(function (prev, paramName) {
        var _a;
        return typeof params[paramName] !== 'function' ? prev : tslib_1.__assign(tslib_1.__assign({}, prev), (_a = {}, _a[paramName] = params[paramName], _a));
    }, {});
};
var resolveSimpleParams = function (str, params) {
    return Object.keys(params).reduce(function (prev, paramName) {
        var param = params[paramName];
        var type = typeof param;
        switch (type) {
            case 'number':
            case 'string':
                var pattern = new RegExp("{{".concat(paramName, "}}"), 'g');
                return prev.replace(pattern, param.toString());
            default:
                return prev;
        }
    }, str);
};
var resolveJSXParams = function (strParts, params) {
    return strParts.map(function (stringPart) {
        var contentTagMatch = stringPart.match(/^<(.+?)>(.*?)<\/.+?>$/);
        if (contentTagMatch && params[contentTagMatch[1]]) {
            return params[contentTagMatch[1]](contentTagMatch[2]);
        }
        var selfClosingTagMatch = stringPart.match(/^<(.+?)[ ]?\/>$/);
        if (selfClosingTagMatch && params[selfClosingTagMatch[1]]) {
            return params[selfClosingTagMatch[1]]('');
        }
        else {
            return React.createElement("span", null, stringPart);
        }
    });
};
var resolveParams = function (str, params) {
    if (params === void 0) { params = {}; }
    var strWithResolvedSimpleParams = resolveSimpleParams(str, params);
    if (isSimpleParams(params)) {
        return strWithResolvedSimpleParams;
    }
    var jsxParams = getOnlyJsxParams(params);
    var jsxParamsRegex = new RegExp(Object.keys(jsxParams).map(function (key) { return "(<".concat(key, ">.*?</").concat(key, ">)|(<").concat(key, "[ ]?/>)"); }).join('|'), 'g');
    var stringPartsAndPlaceholdersArray = strWithResolvedSimpleParams.split(jsxParamsRegex).filter(function (s) { return !!s; }); // ['first part', '<tagName>inner text</tagName>', 'second part']
    var wrappedStringPartsAndElements = resolveJSXParams(stringPartsAndPlaceholdersArray, jsxParams); // [<span>first part</span>, <SomeJSXElement/>, <span>second part</span>]
    return React.createElement.apply(React, tslib_1.__spreadArray([React.Fragment, null], wrappedStringPartsAndElements, false));
};
exports.resolveParams = resolveParams;
var createTranslateFn = function (sourceOrSourceProvider) {
    var sourceProvider = typeof sourceOrSourceProvider === 'function' ? sourceOrSourceProvider : function (key) { return sourceOrSourceProvider[key]; };
    var translateFn = function (key, params) {
        var str = sourceProvider(key) || key;
        return (0, exports.resolveParams)(str, params);
    };
    return translateFn;
};
exports.createTranslateFn = createTranslateFn;
var toBabelLocale = function (lang) {
    // As our simplified and traditional chinese will be "zh-Hans" and "zh-Hant" this is needed to properly transfor to what babel expects
    switch (lang) {
        case 'iw':
            // see #7007
            return 'he';
        case 'zh-Hans':
            return 'zh-CN';
        case 'zh-Hant':
            return 'zh-TW';
        default:
            return lang;
    }
};
exports.toBabelLocale = toBabelLocale;
exports.TranslationContext = React.createContext((function () { return 'no translation function initialized'; }));
var useTranslation = function (prefix) {
    var t = React.useContext(exports.TranslationContext);
    var tp = function (key, params) { return t("".concat(prefix, ".").concat(key), params); };
    return tp;
};
exports.useTranslation = useTranslation;
//# sourceMappingURL=index.js.map